import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { Check } from "lucide-react";
import { toast } from "sonner";

export default function Onboarding() {
  const [steps, setSteps] = useState([]);

  const load = async () => {
    const { data } = await api.get("/onboarding/steps");
    setSteps(data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (step) => {
    try {
      await api.patch(`/onboarding/steps/${step.id}`, { completed: !step.completed });
      toast.success(!step.completed ? "Step completed" : "Step reopened");
      load();
    } catch { toast.error("Failed to update step"); }
  };

  const done = steps.filter(s => s.completed).length;
  const pct = steps.length ? Math.round((done / steps.length) * 100) : 0;

  return (
    <Shell>
      <div className="p-4 sm:p-8 max-w-4xl" data-testid="onboarding-page">
        <div className="label-xs text-amber">&gt; PATH_TO_FIRST_COMMISSION</div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">Roadmap.</h1>
        <p className="mt-3 text-fg-muted font-mono text-sm">Zero to licensed-and-selling. Check off each step.</p>

        <div className="mt-8 border border-term p-6 bg-raised">
          <div className="flex items-center justify-between">
            <div className="font-display text-4xl text-amber">{pct}%</div>
            <div className="label-xs">{done} / {steps.length} COMPLETE</div>
          </div>
          <div className="h-1 bg-muted mt-4">
            <div className="h-full bg-amber transition-all" style={{ width: `${pct}%` }} />
          </div>
        </div>

        <div className="mt-12 relative pl-10 border-l border-term space-y-10">
          {steps.map((s, idx) => (
            <div key={s.id} className="relative slide-up" style={{ animationDelay: `${idx * 40}ms` }} data-testid={`step-${s.order}`}>
              <div className={`absolute -left-[49px] top-1 w-6 h-6 flex items-center justify-center border ${s.completed ? "bg-amber border-amber" : "bg-black border-strong"}`}>
                {s.completed && <Check size={12} className="text-black" strokeWidth={3} />}
              </div>
              <div className="flex items-start justify-between gap-6 flex-wrap">
                <div className="flex-1 min-w-[200px]">
                  <div className="label-xs text-amber">STEP {String(s.order).padStart(2, "0")}</div>
                  <div className={`font-display text-2xl mt-1 ${s.completed ? "line-through text-fg-subtle" : ""}`}>{s.title}</div>
                  <p className="text-sm text-fg-muted mt-2 max-w-2xl leading-relaxed font-mono">{s.description}</p>
                  {s.completed_at && <div className="text-[10px] text-gain font-mono mt-2 uppercase tracking-widest">✓ DONE · {new Date(s.completed_at).toLocaleDateString()}</div>}
                </div>
                <button
                  onClick={() => toggle(s)}
                  data-testid={`toggle-step-${s.order}`}
                  className={s.completed ? "btn-ghost" : "btn-primary"}
                >
                  {s.completed ? "Reopen" : "Mark Done"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Shell>
  );
}
